var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scheme"},[_c('object',{ref:"svgObject",attrs:{"id":"svg-object","type":"image/svg+xml","data":_vm.svgPath}}),(_vm.loading)?_c('v-progress-circular',{staticClass:"scheme_loader",attrs:{"width":3,"color":"rgba(0, 0, 0, 0.3)","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }